var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error404"},[_c('Portlet',{attrs:{"title":_vm.$t('errorComponent.backendEndpointNotAvailable'),"sub-title":"404","icon":"bug"}},[_c('p',[_vm._v(_vm._s(_vm.$t('errorComponent.pleaseReportToDevelopmentTeam')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }